"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _queryString = _interopRequireDefault(require("query-string"));

var _useAuthService2 = require("../hooks/useAuthService");

var _AuthLoading = _interopRequireDefault(require("./AuthLoading"));

var LoginRedirect = function LoginRedirect() {
  var _useAuthService = (0, _useAuthService2.useAuthService)(),
      tokenService = _useAuthService.tokenService,
      loginUrl = _useAuthService.loginUrl;

  var _useLocation = (0, _reactRouterDom.useLocation)(),
      search = _useLocation.search;

  var _qs$parseUrl = _queryString.default.parseUrl(loginUrl),
      url = _qs$parseUrl.url,
      query = _qs$parseUrl.query;

  var fullLoginUrl = _queryString.default.stringifyUrl({
    url,
    query: {
      callbackUrl: "".concat(query.callbackUrl).concat(search)
    }
  });

  var token = tokenService.getDecodedToken();

  if (token.isValid) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: "/"
    });
  }

  window.location.assign(fullLoginUrl);
  return /*#__PURE__*/_react.default.createElement(_AuthLoading.default, null);
};

var _default = /*#__PURE__*/(0, _react.memo)(LoginRedirect);

exports.default = _default;